import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, isEmpty, forEach, map, includes } from "lodash";
import update from "immutability-helper";

import { fetchGet, fetchPost, fetchPut } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";

import Picture from "../../Common/Picture";
import TagColor from "../../Common/TagColor";
import CloseIcon from "../../Common/CloseIcon";
import ProfileLink from "../../Common/ProfileLink";
import CustomButton from "../../Common/CustomButton";
import CustomSelect from "../../Common/CustomSelect";
import Override from "../CorrectConfirmValue/Override";
import SmartSearchProfiles from "../../Common/SmartSearchProfiles";

import {
  getAttributeValue,
  isUnknownProfile,
  getLovValue,
} from "../../../utils/profile";
import { getLov } from "../../../utils/lov";
import { getFrDetails } from "../../../utils/detectionDetails";

import { AWS, MS, FR, LUKE, CONTEXT } from "../../../constants/common";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  dialogContainer: {
    width: "1050px",
    maxWidth: "1050px",
  },
  dialogOverride: {
    height: "650px",
    width: "450px",
  },
  closeIcon: {
    display: "flex",
    justifyContent: "flex-end",
  },
  radio: {
    color: colors.black87,
    fontSize: "1em !important",
  },
  pictureContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${colors.veryLighPink}`,
    width: "72px",
    height: "72px",
  },
  scoreBox: {
    border: `1px solid ${colors.veryLighPink}`,
    color: colors.black87,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "2px",
  },
  borderedBox: {
    border: `1px solid ${colors.black542}`,
    padding: "12px",
  },
  link: {
    color: colors.primary,
  },
  scoreContainer: {
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      maxWidth: "30px",
      maxHeight: "30px",
    },
  },
  potentialMatchesItem: {
    paddingBottom: "10px",
    marginBottom: "10px",
    borderBottom: `1px solid ${colors.veryLighPink}`,
  },
};

const viewModes = {
  PHOTO: "PHOTO",
  PROFILE: "PROFILE",
};

const StyledTableCell = withStyles((theme) => ({
  root: {
    border: `1px solid ${colors.black542}`,
  },
}))(TableCell);

const FrResultsNew = (props) => {
  const {
    classes,
    nfrEnabled,
    triggerNode,
    rootEventGroup,
    humanIdentification,
    refreshRootEventGroup,
    refreshHumanIdentification,
    language,
    open,
    onOpen,
    onClose,
    onlyOverride = false,
    disabled = false,
  } = props;

  const [lov, setLov] = React.useState({});
  const [viewMode, setViewMode] = React.useState(viewModes.PHOTO);
  const [matchedProfiles, setMatchedProfiles] = React.useState({ init: false });
  const [overrideData, setOverrideData] = React.useState();
  const [selectedProfile, setSelectedProfile] = React.useState("");
  //const [userSelected, setUserSelected] = React.useState();
  const [editRiskLevel, setEditRiskLevel] = React.useState(false);
  const [potentialMatchRadio, setPotentialMatchRadio] = React.useState();

  const fr = getFrDetails(humanIdentification);

  React.useEffect(() => {
    let isSuscribed = true;
    getLov("riskLevel").then((riskLevel) => {
      if (isSuscribed) {
        setLov({ riskLevel });
      }
    });
    return () => (isSuscribed = false);
  }, []);

  React.useEffect(() => {
    const fetchMatchedProfiles = async () => {
      try {
        const services = [MS, AWS, FR];
        let newMatchedProfiles = { init: true };
        for (let i = 0; i < fr.length; i++) {
          for (let j = 0; j < services.length; j++) {
            let profileId = get(fr, [i, services[j], "profileId"]);
            if (
              profileId &&
              !isUnknownProfile(profileId) &&
              !newMatchedProfiles[profileId]
            ) {
              newMatchedProfiles[profileId] = await fetchGet(
                `profiles/${profileId}`
              );
            }
          }
        }
        setMatchedProfiles(newMatchedProfiles);
      } catch (e) {
        console.log(e);
      }
    };
    if (open && !matchedProfiles.init && fr && fr.length > 0) {
      fetchMatchedProfiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, fr]);

  const getDataByPhoto = () => {
    let rows = [];
    if (fr) {
      forEach(fr, (img) => {
        let row = {
          img: img.img,
          profiles: {},
          lukeIndex: img.lukeIndex,
          faceRecognized: img.faceRecognized,
        };
        forEach([AWS, MS, FR], (service) => {
          let profileId = get(img, [service, "profileId"]);
          if (profileId && !isUnknownProfile(profileId)) {
            if (!row.profiles[profileId]) {
              row.profiles[profileId] = {
                [service]: get(img, [service, "confidenceIndex"]),
              };
            } else {
              row.profiles[profileId][service] = get(img, [
                service,
                "confidenceIndex",
              ]);
            }
          }
        });
        rows.push(row);
      });
    }
    return rows;
  };

  const getDataByProfile = () => {
    let profiles = {};
    let matchedProfileId;
    forEach(fr, (img) => {
      let imgId = get(img, ["img", 0, "id"]);
      Object.keys(img)
        .filter((k) => [AWS, MS, FR].includes(k))
        .sort((a, b) =>
          img[a].confidenceIndex > img[b].confidenceIndex ? -1 : 1
        )
        .forEach((service, index) => {
          //Highest score determine the matched profile
          if (index === 0) {
            matchedProfileId = get(img, [service, "profileId"]);
          }
          let profileId = get(img, [service, "profileId"]);
          if (profileId && !isUnknownProfile(profileId)) {
            if (!profiles[profileId]) {
              profiles[profileId] = {
                images: {
                  [imgId]: {
                    url: get(img, ["img", 0, "url"]),
                    [LUKE]:
                      matchedProfileId === profileId ? img.lukeIndex : null,
                    faceRecognized: img.faceRecognized,
                    [service]: get(img, [service, "confidenceIndex"]),
                  },
                },
              };
            } else {
              if (!profiles[profileId].images[imgId]) {
                profiles[profileId].images[imgId] = {
                  url: get(img, ["img", 0, "url"]),
                  [LUKE]: matchedProfileId === profileId ? img.lukeIndex : null,
                  faceRecognized: img.faceRecognized,
                  [service]: get(img, [service, "confidenceIndex"]),
                };
              } else {
                profiles[profileId].images[imgId][service] = get(img, [
                  service,
                  "confidenceIndex",
                ]);
              }
            }
          }
        });
    });
    return profiles;
  };

  const getProfileSuggestions = async (input) => {
    try {
      let suggestions = await fetchPost("profiles/search", {
        search_text: input,
        types: [1],
      });
      forEach(suggestions, (sugg) => {
        sugg.name = `${get(sugg, ["firstname"])} ${get(sugg, ["lastname"])}`;
      });
      return suggestions;
    } catch (e) {
      console.log(e);
    }
  };

  const saveRiskLevel = async () => {
    setEditRiskLevel(false);
    try {
      if (get(humanIdentification, ["parent", "id"])) {
        await fetchPut(
          `event_groups/${get(humanIdentification, ["parent", "id"])}`,
          {
            risk_level: parseInt(editRiskLevel),
          }
        );
        refreshRootEventGroup();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const renderScoresHeader = () => {
    return (
      <Grid container direction="column">
        <Grid item>
          <span>{I18n.get("site_scores")}</span>
          <span
            style={{
              marginLeft: "10px",
              fontStyle: "italic",
              fontWeight: "400",
              fontSize: "0.875em",
              color: colors.black54,
            }}
          >
            {I18n.get("site_inPercent")}
          </span>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item className={classes.scoreContainer}>
              <img src={images.lLogo} alt="l" />
            </Grid>
            <Grid item className={classes.scoreContainer}>
              <img src={images.microsoftLogo} alt="microsoft" />
            </Grid>
            <Grid item className={classes.scoreContainer}>
              <img src={images.awsLogo} alt="aws" />
            </Grid>
            {nfrEnabled && (
              <Grid item className={classes.scoreContainer}>
                <img src={images.nfrLogo} alt="nfr" />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderScore = (score, luke = false) => {
    return (
      <Box
        className={classes.scoreBox}
        style={{ border: luke ? `2px solid ${colors.black87}` : "" }}
      >
        {score || score === 0 ? Math.round(score * 100) : "-"}
      </Box>
    );
  };

  const renderScores = (msScore, awsScore, frScore, lukeScore) => {
    return (
      <Grid container alignItems="center">
        <Grid item className={classes.scoreContainer}>
          {(lukeScore || lukeScore === 0) && renderScore(lukeScore, true)}
        </Grid>
        <Grid item className={classes.scoreContainer}>
          {renderScore(msScore)}
        </Grid>
        <Grid item className={classes.scoreContainer}>
          {renderScore(awsScore)}
        </Grid>
        {nfrEnabled && (
          <Grid item className={classes.scoreContainer}>
            {renderScore(frScore)}
          </Grid>
        )}
      </Grid>
    );
  };

  const renderProfile = (profileId) => {
    if (!get(matchedProfiles, [profileId])) {
      return <CircularProgress size={20} />;
    }
    return (
      <Grid container>
        <Grid
          item
          className={classes.pictureContainer}
          style={{ marginRight: "10px" }}
        >
          <Picture
            url={get(matchedProfiles, [profileId, "images", 0, "url"])}
            alt="captured"
            maxHeight={70}
            style={{ maxWidth: "70px", maxHeight: "70px" }}
          />
        </Grid>
        <Grid item className="flexCenter">
          <Grid container direction="column">
            <ProfileLink
              profile={get(matchedProfiles, [profileId])}
              onlyLink
              noTitle
              containerStyle={{ fontSize: "1em" }}
            />
            <Grid item style={{ marginTop: "5px" }}>
              <Grid container>
                <TagColor
                  color={`#${get(matchedProfiles, [
                    profileId,
                    "tag",
                    "color_rgb",
                  ])}`}
                />
                <Grid item className="text-54">
                  {get(matchedProfiles, [profileId, "tag", `name_${language}`])}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderProfileWithPhotos = (
    profile,
    confidence,
    matched = false,
    overriden = false
  ) => {
    if (!profile) {
      return (
        <Box
          className="flexCenter text-54"
          style={{ width: "100%", height: "110px", justifyContent: "center" }}
        >
          {I18n.get("site_noMatchedProfileFound")}
        </Box>
      );
    }
    if (!get(profile, ["id"])) {
      return (
        <Box
          className="flexCenter"
          style={{ width: "100%", height: "110px", justifyContent: "center" }}
        >
          <CircularProgress size={20} />
        </Box>
      );
    }
    if (isUnknownProfile(get(profile, ["id"]))) {
      return (
        <Grid container>
          <Grid item style={{ height: "70px" }}>
            <img
              src={images.humanUnknownLog}
              alt="unknown_human"
              height="70px"
            />
          </Grid>
          <Grid item className="text-87" style={{ marginLeft: "10px" }}>
            {`${getAttributeValue(profile, 31)} ${getAttributeValue(
              profile,
              32
            )}`}
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid container direction="column">
        <Grid item style={{ marginBottom: "12px" }}>
          <Grid container alignItems="center">
            {(matched || overriden) && (
              <Grid item className="flexCenter" style={{ marginRight: "10px" }}>
                <img
                  src={
                    matched
                      ? images.checkCircleColored
                      : images.overrideIconGrey
                  }
                  height="14px"
                  alt="icon"
                />
              </Grid>
            )}
            <ProfileLink
              profile={profile}
              score={confidence}
              onlyLink
              noTitle
              containerStyle={{ marginRight: "10px", fontSize: "1em" }}
            />
            <Grid item style={{ margin: "0px 15px" }}>
              <Grid container>
                <TagColor color={`#${get(profile, ["tag", "color_rgb"])}`} />
                <Grid item className="text-54">
                  {get(profile, ["tag", `name_${language}`])}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            maxWidth: "380px",
            overflow: "auto",
            paddingBottom: "5px",
          }}
        >
          <Grid container wrap="nowrap">
            {get(profile, ["images"]) &&
              get(profile, ["images"])
                .filter((img) => img.enrollment_status === true)
                .map((img, index) => (
                  <Grid
                    item
                    className={classes.pictureContainer}
                    key={index}
                    style={{
                      marginRight:
                        index < get(profile, ["images"]).length - 1
                          ? "10px"
                          : "",
                    }}
                  >
                    <Picture
                      url={img.url}
                      alt="captured"
                      maxHeight={70}
                      style={{ maxWidth: "70px", maxHeight: "70px" }}
                    />
                  </Grid>
                ))}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderPotentialMatches = () => {
    const getBestPhotoScore = (images) => {
      let max = null;
      if (images) {
        Object.keys(images).forEach((imgId) => {
          if (images[imgId][LUKE] > max) {
            max = images[imgId][LUKE];
          }
        });
      }
      return max;
    };

    let profiles = getDataByProfile();
    let profileIds = new Set();
    forEach(profiles, (v, k) => {
      forEach(get(v, ["images"]), (value, key) => {
        if (get(value, ["LUKE"]) > props.potentialMatchesThreshold) {
          profileIds.add(k);
        }
      });
    });
    profileIds = Array.from(profileIds);

    return (
      <Grid item className={classes.borderedBox}>
        <Grid container direction="column">
          {profiles &&
            Object.keys(profiles)
              .filter(
                (profileId) =>
                  profileId !==
                    (props.overriden
                      ? get(props, ["overriden", "profile", "id"])
                      : get(humanIdentification, ["profile", "id"])) &&
                  includes(profileIds, profileId)
              )
              .map((profileId) => (
                <Grid
                  item
                  key={profileId}
                  className={classes.potentialMatchesItem}
                >
                  <Grid container wrap="nowrap">
                    <Grid
                      item
                      className="flexCenter"
                      style={{ marginRight: "12px" }}
                    >
                      <Radio
                        color="primary"
                        checked={selectedProfile === profileId}
                        onChange={() => {
                          setSelectedProfile(profileId);
                          //setUserSelected(true);
                          setPotentialMatchRadio("");
                        }}
                      />
                    </Grid>
                    <Grid item>
                      {renderProfileWithPhotos(
                        matchedProfiles[profileId],
                        getBestPhotoScore(get(profiles, [profileId, "images"]))
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              ))}
          <Grid item className={classes.potentialMatchesItem}>
            <Grid container>
              <Grid item className="flexCenter" style={{ marginRight: "12px" }}>
                <Radio
                  color="primary"
                  onChange={() => {
                    setPotentialMatchRadio("search");
                    setSelectedProfile(false);
                  }}
                  checked={
                    potentialMatchRadio === "search"
                    // selectedProfile &&
                    // selectedProfile !== "create" &&
                    // !Object.keys(profiles).includes(selectedProfile)
                    //   ? true
                    //   : false
                  }
                />
              </Grid>
              <Grid item className="flexCenter" style={{ width: "264px" }}>
                <SmartSearchProfiles
                  language={language}
                  getSuggestions={getProfileSuggestions}
                  filter={["name"]}
                  onFocus={() => {
                    setPotentialMatchRadio("search");
                    setSelectedProfile(false);
                  }}
                  onSelect={(profile) => {
                    setSelectedProfile(profile.id);
                    //setUserSelected(true);
                    setMatchedProfiles(
                      update(matchedProfiles, {
                        [profile.id]: { $set: profile },
                      })
                    );
                    setPotentialMatchRadio("search");
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item className="flexCenter" style={{ marginRight: "12px" }}>
                <Radio
                  color="primary"
                  checked={potentialMatchRadio === "create"}
                  onChange={() => {
                    setSelectedProfile("create");
                    //setUserSelected(true);
                    setPotentialMatchRadio("create");
                  }}
                />
              </Grid>
              <Grid
                item
                className="text-54 flexCenter"
                onClick={() => {
                  setSelectedProfile("create");
                  //setUserSelected(true);
                  setPotentialMatchRadio("create");
                }}
                style={{ cursor: "pointer" }}
              >
                {I18n.get("site_noneAboveCreateProfile")}
              </Grid>
            </Grid>
          </Grid>
          <Grid item className="text-center" style={{ marginTop: "20px" }}>
            <CustomButton
              color="primary"
              variant="contained"
              onClick={() => {
                setOverrideData({
                  currentProfile: get(humanIdentification, ["profile"]),
                  newProfile:
                    selectedProfile === "create"
                      ? selectedProfile
                      : get(matchedProfiles, [selectedProfile]),
                });
              }}
              disabled={!selectedProfile}
              startIcon={
                <img
                  src={
                    !selectedProfile
                      ? images.overrideIconGrey
                      : images.overrideIconWhite
                  }
                  alt="override"
                />
              }
            >
              {I18n.get("site_override")}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderByPhoto = () => {
    let rows = getDataByPhoto();
    return (
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell style={{ width: "100px", lineHeight: "1.3" }}>
              {I18n.get("site_capturedPhotos2")}
            </StyledTableCell>
            <StyledTableCell>{I18n.get("sidebar_profiles")}</StyledTableCell>
            <StyledTableCell style={{ width: nfrEnabled ? "190px" : "150px" }}>
              {renderScoresHeader()}
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .sort((a, b) => (a.lukeIndex < b.lukeIndex ? 1 : -1))
            .map((item, index) => (
              <TableRow key={index}>
                <StyledTableCell>
                  <Grid container style={{ position: "relative" }}>
                    <Grid item className="flexCenter">
                      {item.faceRecognized && (
                        <img
                          src={images.greenCheckmarkWhite}
                          width="16px"
                          alt="match"
                          style={{
                            position: "absolute",
                            bottom: "-2px",
                            right: "-8px",
                          }}
                        />
                      )}
                    </Grid>
                    <Grid
                      item
                      className={classes.pictureContainer}
                      style={{ margin: "5px 0px" }}
                    >
                      <Picture
                        url={get(item, ["img", 0, "url"])}
                        alt="captured"
                        maxHeight={70}
                        style={{ maxWidth: "70px", maxHeight: "70px" }}
                      />
                    </Grid>
                  </Grid>
                </StyledTableCell>
                <StyledTableCell>
                  <Grid container direction="column">
                    {isEmpty(item.profiles) ? (
                      <Grid
                        item
                        className="text-54"
                        style={{ fontStyle: "italic" }}
                      >
                        {I18n.get("site_noMatch")}
                      </Grid>
                    ) : (
                      Object.keys(item.profiles).map((profileId, index) => (
                        <Grid
                          item
                          key={profileId}
                          style={{
                            marginTop: index > 0 ? "10px" : "0px",
                            marginLeft: index > 0 ? "30px" : "",
                          }}
                        >
                          {renderProfile(profileId)}
                        </Grid>
                      ))
                    )}
                  </Grid>
                </StyledTableCell>
                <StyledTableCell>
                  <Grid container direction="column">
                    {Object.keys(item.profiles).map((profileId, i) => (
                      <Grid
                        item
                        key={i}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          height: "72px",
                          marginTop: i > 0 ? "10px" : "0px",
                        }}
                      >
                        {renderScores(
                          get(item, ["profiles", profileId, MS]),
                          get(item, ["profiles", profileId, AWS]),
                          get(item, ["profiles", profileId, FR]),
                          i > 0 ? null : get(item, ["lukeIndex"])
                        )}
                      </Grid>
                    ))}
                  </Grid>
                </StyledTableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    );
  };

  const renderByProfile = () => {
    let profiles = getDataByProfile();
    return (
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>{I18n.get("sidebar_profiles")}</StyledTableCell>
            <StyledTableCell style={{ width: "100px", lineHeight: "1.3" }}>
              {I18n.get("site_capturedPhotos2")}
            </StyledTableCell>
            <StyledTableCell style={{ width: "190px" }}>
              {renderScoresHeader()}
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(profiles)
            .filter((id) =>
              get(profiles, [
                id,
                "images",
                get(Object.keys(get(profiles, [id, "images"])), [0]),
                LUKE,
              ])
            )
            .map((profileId) => (
              <TableRow key={profileId}>
                <StyledTableCell className="flexCenter">
                  {renderProfile(profileId)}
                </StyledTableCell>
                <StyledTableCell>
                  <Grid container direction="column">
                    {Object.keys(profiles[profileId].images).map((imgId) => (
                      <Grid
                        item
                        key={imgId}
                        className={classes.pictureContainer}
                        style={{ margin: "5px 0px" }}
                      >
                        <Picture
                          url={profiles[profileId].images[imgId].url}
                          alt="captured_photo"
                          maxHeight={70}
                          style={{ maxWidth: "70px", maxHeight: "70px" }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </StyledTableCell>
                <StyledTableCell>
                  <Grid container direction="column">
                    {Object.keys(profiles[profileId].images).map((imgId) => (
                      <Grid
                        item
                        key={imgId}
                        className="flexCenter"
                        style={{ height: "82px" }}
                      >
                        {renderScores(
                          profiles[profileId].images[imgId][MS],
                          profiles[profileId].images[imgId][AWS],
                          profiles[profileId].images[imgId][FR],
                          profiles[profileId].images[imgId][LUKE]
                        )}
                      </Grid>
                    ))}
                  </Grid>
                </StyledTableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    );
  };

  return (
    <>
      <Box component="span" onClick={() => !disabled && onOpen()}>
        {triggerNode}
      </Box>
      {open &&
        (overrideData ? (
          <Dialog
            open={true}
            classes={{
              paperScrollPaper: classes.dialogOverride,
            }}
          >
            <Override
              section={props.section}
              close={() => {
                setOverrideData(null);
                onClose();
              }}
              dacId={get(humanIdentification, ["parent", "id"])}
              tabs={props.tabs}
              overrideData={overrideData}
              photos={map(fr, (item) => ({
                type: CONTEXT,
                url: get(item, ["img", 0, "url"]),
              }))}
              detectionEventGroup={humanIdentification}
              setOverrideData={setOverrideData}
              refresh={() => {
                refreshRootEventGroup();
                refreshHumanIdentification();
              }}
              isLive={false}
            />
          </Dialog>
        ) : (
          <Dialog
            open={open}
            classes={{ paper: !onlyOverride ? classes.dialogContainer : "" }}
          >
            <Grid
              container
              wrap="nowrap"
              direction="column"
              alignItems="stretch"
              style={{
                height: "100%",
                padding: "12px 24px 24px",
                minHeight: "600px",
              }}
            >
              <Grid item style={{ marginBottom: "20px" }}>
                <Grid container alignItems="center">
                  {!onlyOverride ? (
                    <>
                      <Grid item style={{ marginRight: "100px" }}>
                        <span
                          className="bold-500 text-87"
                          style={{ marginRight: "10px" }}
                        >
                          {I18n.get("site_status")}:
                        </span>
                        <span className="text-54">
                          {get(rootEventGroup, ["status", `name_${language}`])}
                        </span>
                      </Grid>
                      <Grid item>
                        <Grid container alignItems="center">
                          <Grid item className="flexCenter">
                            {get(rootEventGroup, ["risk_level"]) > 0 && (
                              <img
                                src={images.threatFlag}
                                height="16px"
                                alt="threat_flag"
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            className="bold-500 text-87"
                            style={{ margin: "10px" }}
                          >
                            {I18n.get("site_riskLevel")}:
                          </Grid>
                          {editRiskLevel ? (
                            <Grid item style={{ width: "120px" }}>
                              <CustomSelect
                                name="riskLevel"
                                value={
                                  editRiskLevel !== true
                                    ? editRiskLevel
                                    : get(rootEventGroup, ["risk_level"])
                                }
                                onChange={(e) =>
                                  setEditRiskLevel(e.target.value)
                                }
                                options={
                                  lov.riskLevel &&
                                  lov.riskLevel.map((t) => ({
                                    id: t.id.toString(),
                                    name: t["name_" + language],
                                  }))
                                }
                              />
                            </Grid>
                          ) : (
                            <Grid item className="text-54">
                              {getLovValue(
                                "riskLevel",
                                get(rootEventGroup, ["risk_level"]),
                                lov,
                                language
                              )}
                            </Grid>
                          )}
                          {editRiskLevel ? (
                            <Grid item>
                              <CustomButton
                                color="primary"
                                style={{ margin: "0px 10px" }}
                                onClick={() => setEditRiskLevel(false)}
                              >
                                {I18n.get("site_cancel")}
                              </CustomButton>
                              <CustomButton
                                variant="contained"
                                color="primary"
                                onClick={saveRiskLevel}
                                disabled={
                                  !parseInt(editRiskLevel) &&
                                  parseInt(editRiskLevel) !== 0
                                }
                              >
                                {I18n.get("site_save")}
                              </CustomButton>
                            </Grid>
                          ) : (
                            <Grid
                              onClick={() => setEditRiskLevel(true)}
                              style={{ marginLeft: "10px" }}
                            >
                              <img
                                src={images.editIconColored}
                                alt="edit"
                                style={{ cursor: "pointer" }}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs />
                    </>
                  ) : (
                    <>
                      <Grid item xs={2} />
                      <Grid item xs className="text-center bold-500 black-87">
                        {I18n.get("site_override")}
                      </Grid>
                    </>
                  )}
                  <Grid item xs={2} className={classes.closeIcon}>
                    <CloseIcon closeFunction={onClose} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container>
                  <Grid item style={{ width: "400px" }}>
                    <Grid container direction="column">
                      <Grid item className="bold-500 text-87">
                        {I18n.get("site_matchedProfile")}
                      </Grid>
                      <Grid item className={classes.borderedBox}>
                        {props.overriden
                          ? renderProfileWithPhotos(
                              get(props, ["overriden", "profile"]),
                              1,
                              false,
                              true
                            )
                          : renderProfileWithPhotos(
                              get(humanIdentification, ["profile"]),
                              get(humanIdentification, ["luke_index"]),
                              true
                            )}
                      </Grid>
                      <Grid item style={{ marginTop: "30px" }}>
                        <Grid container>
                          <Grid item className="bold-500 text-87">
                            {I18n.get("site_potentialMatches")}
                          </Grid>
                          <Grid item xs style={{ textAlign: "right" }}>
                            {`LUKE index > ${parseInt(
                              props.potentialMatchesThreshold * 100
                            )} %`}
                          </Grid>
                        </Grid>
                      </Grid>
                      {renderPotentialMatches()}
                    </Grid>
                  </Grid>
                  {!onlyOverride && (
                    <Grid item xs style={{ marginLeft: "24px" }}>
                      <Grid container direction="column">
                        <Grid item className="bold-500 text-87">
                          {I18n.get("site_capturedPhotosFrResults")}
                        </Grid>
                        <Grid item>
                          <RadioGroup
                            row
                            name="view"
                            value={viewMode}
                            onChange={(e) => setViewMode(e.target.value)}
                          >
                            <FormControlLabel
                              value={viewModes.PHOTO}
                              control={<Radio color="primary" />}
                              label={I18n.get("site_byPhoto")}
                              labelPlacement="end"
                              classes={{ label: classes.radio }}
                            />
                            <FormControlLabel
                              value={viewModes.PROFILE}
                              control={<Radio color="primary" />}
                              label={I18n.get("site_byProfile")}
                              labelPlacement="end"
                              classes={{ label: classes.radio }}
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid item>
                          {viewMode === viewModes.PHOTO
                            ? renderByPhoto()
                            : renderByProfile()}
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
        ))}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    potentialMatchesThreshold: get(state, [
      "user",
      "potentialMatchesThreshold",
    ]),
    nfrEnabled: get(state, ["user", "nfrEnabled"]),
    language: get(state, ["user", "language"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(FrResultsNew));
